import {AddressFestEnum} from '../v2024';

export const AddressFestEnumLabels = {
    Fest: 'Fest' as AddressFestEnum,
    NichtFest: 'NichtFest' as AddressFestEnum
};

